"use client";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getListingsApi, appResponse } from "@/util";
import { IAppStore, IListings, IProperties } from "@/util/types";
import { Box, Skeleton } from "@mui/material";
import ListCard from "@/components/listings/listcard";
import { AppSize, pxToRem } from "@/util";
import { makeStyles } from "tss-react/mui";
import FootPagination from "./footPagination";
import { usePathname, useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { setSearch } from "@/store/propertyfilter";


const ListingsOnly = () => {
  const { classes } = styles();
  const router = useRouter();
  const pathname = usePathname();
  const limit = 10;
  const [page, setPage] = React.useState<number>(1);
   const dispatch=useDispatch();
 const propFilter=useSelector((appStore:IAppStore)=>appStore.propertyFilter);

  const { data, isLoading ,refetch,isRefetching} = useQuery<appResponse<IListings[]>>({
    queryKey: ["simpleListings", { limit, page }],
    queryFn: () => getListingsApi({ limit, page,propertyName:propFilter.propertyName,location:propFilter.location,propertyType:propFilter.propertyType,price:propFilter.priceRange,listingStatus:propFilter.status,sort:propFilter.sort }),
  });
 
React.useEffect(() => { 
  if (propFilter.isSearch) {
    handleSearch();
  }
}, [propFilter.isSearch]);


  const handleSearch =() => {
  dispatch(setSearch(false),refetch());
};


const handlePageChange = (e: React.ChangeEvent<unknown>, value: React.SetStateAction<number>) => {
       if (setPage)setPage(value as number);
        if (value === 1) {
        router.push(`${pathname}`);
        } else {
          const params=new URLSearchParams({page:value.toString()});
          //params.set('page',value.toString());
         router.replace(`${pathname}?${params.toString()}`)
       
        }
      };
  return (
    <Box padding={4} className={classes.container}>
      {(isLoading||isRefetching) ? (
        <Box className={classes.sub}>
          <Skeleton className={classes.skel} />
          <Skeleton className={classes.skel} />
          <Skeleton className={classes.skel} />
        </Box>
      ) : (
        <Box className={classes.sub}>
          {data?.payload?.map((listing) => (
            <ListCard
              key={listing._id}
              data={listing.property as IProperties}
              price={`${listing.price}`}
              link={`/projects/properties/listings/${listing._id}`}
              isLink={true}
            />
          ))}
        </Box>
      )}
      <Box className={classes.pagination}>
        <FootPagination page={Number.parseInt(`${data?.metadata?.page||"1"}`)} isDivider={false} onChange={handlePageChange} count={data?.metadata?.total?Math.ceil(Number.parseInt(`${data.metadata?.total}`)/Number.parseInt(`${data.metadata?.limit}`)):0}/>
      </Box>
    </Box>
  );
};

export default ListingsOnly;

const styles = makeStyles()((theme) => ({
  container: {
    padding: `0px ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(10)} ${pxToRem(15)}`, // or even `0`
    },
  },
  skel: {
    display: "flex",
    height: pxToRem(420),
  },
  pagination: {
    marginBottom: theme.spacing(4),
  },
  sub: {
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    gap: theme.spacing(4),
      [theme.breakpoints.down("md")]: {
      // border: "1px solid red",
        gridTemplateColumns: "repeat(2,1fr)",
    },
     [theme.breakpoints.down("sm")]: {
      // border: "1px solid red",
        gridTemplateColumns: "repeat(1,1fr)",
    }
  },
}));
